<script>
import { computed } from '@vue/runtime-core';
import { useStore } from 'vuex';
export default {
  setup(){
    const store  = useStore();
    const data = computed(()=> store.getters.student);

    return {data};
  }
}
</script>

<template>
<div class="main">
    <router-link v-for="item in data" :key="item.year" :to="`/member/${item.year}`" class="link">
        {{item.year}}學年度
    </router-link>
</div>
 
</template>

<style lang="scss" scoped>
.main{
  display:flex;
  flex-wrap: wrap;
  margin-left: 30%;
  margin-right: 30%;
  a:nth-child(4n-3){background-color: #007acc;}
  a:nth-child(4n-2){background-color: #014c8f;}
  a:nth-child(4n-1){background-color: #29A0AD;}
  a:nth-child(4n){background-color: #FF667F;}
   >.link{
      width:100% ;
      padding: 2%;
      color:white;
      text-decoration:none;
      text-align: center;
      margin: 1% 1% 1% 1%;
      border-radius: 15px;
      font-size: 30px;
    }
}


</style>